<script setup>

import { KNOLIA } from '@/knolia';
import { onMounted, onUpdated, ref, watch } from 'vue';
import Activities from '../components/skill-card/Activities.vue';
import { Gems } from '../gems';

const userData = ref({})
const expandedCriterias = ref({ activities: [], extraActivities: [], tasksWithoutParent: [], opSkillsWithoutParent: [] })
const knowledges = ref([])
const defaultImage = ref(require('@/images/default.png'))
let showAll = ref(false)

onMounted(async () => {
    const response = await KNOLIA.CallBackEnd('get', `get-user`)

    userData.value = response.data.user

    const responseSkillCard = await KNOLIA.CallBackEnd('get', `get-skill-card`)

    expandedCriterias.value.activities = responseSkillCard.data.activities
    expandedCriterias.value.extraActivities = responseSkillCard.data.extra_activities
    expandedCriterias.value.tasksWithoutParent = responseSkillCard.data.tasks_without_parent
    expandedCriterias.value.opSkillsWithoutParent = responseSkillCard.data.op_skills_without_parent
    knowledges.value = responseSkillCard.data.knowledges
})

onUpdated(() => {
    const divTeams = document.getElementById('div-teams')

    let tooltip = '[sem equipa]'

    if(userData.value.assigned_teams?.length > 0) {
        tooltip = ''
        userData.value.assigned_teams.forEach(elem => tooltip += elem.designation + ', ')
    }

    if(divTeams)
        Gems.Tooltip(divTeams, `Equipa(s): \r\n\r\n${tooltip.replaceAll(",", "\n").trim()}`, 'tooltip tooltip-left')
})

watch(showAll, (e) => {
    if (e)
        document.querySelectorAll(".fa-chevron-down").forEach(elem => elem.click())
    else
        document.querySelectorAll(".fa-chevron-up").forEach(elem => elem.click())
})

</script>


<template>
    <div class="div-container">
        <div class="div-header-container">
            <div id="div-user-header">
                <div id="div-user-photo">
                    <img id="div-logo" class="img-user-photo" :src="userData.src" @error="$event.target.src = defaultImage">
                </div>

                <div id="div-user-info">
                    <div id="div-name"><strong>{{ userData.complete_name }}</strong></div>
                    
                    <div><strong>Nº Interno:</strong> {{ userData.user_internal }}</div>

                    <div><strong>Função:</strong> {{ userData.user_job }}</div>

                    <div id="div-teams">
                        <strong>Equipas: </strong>
                        <span v-if="userData.assigned_teams?.length == 0">[sem equipa]</span>
                        <span v-else-if="userData.assigned_teams?.length == 1" v-for="team in userData.assigned_teams" :key="team">{{ team.designation }}</span>
                        <span v-else>{{ userData.assigned_teams?.length }} equipas</span>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="div-skills-data"> </div>
        <div v-if="expandedCriterias.activities.length > 0">
            <Activities v-if="expandedCriterias.activities.length > 0" :expanded-criterias="expandedCriterias.activities" :is-activities-job="true">
                <template #title>
                    <div class="div-activities-container">
                        <div>Atividades</div>
                        <div class="show-all-container cursor-pointer" @click="showAll = !showAll">
                            <span>Expandir/Fechar tudo</span>
                            <i class="icon fas" :class="{ 'fa-plus-square': !showAll, 'fa-minus-square': showAll }" />
                        </div>
                    </div>
                </template>
            </Activities>
        </div>

        <div v-if="expandedCriterias.extraActivities.length > 0">
            <Activities v-if="expandedCriterias.extraActivities.length > 0" :expanded-criterias="expandedCriterias.extraActivities" :is-activities-job="false">
                <template #title>Atividades fora do âmbito da função</template>
            </Activities>
        </div>

        <div v-show="knowledges.length > 0">
            <div class="div-list-name">
                Conhecimentos
            </div>

            <div class="div-element" v-for="knowledge in knowledges" :key="knowledge.id">
                {{ knowledge.designation }}
            </div>
        </div>

        <div v-show="expandedCriterias.tasksWithoutParent.length > 0">
            <div class="div-list-name">
                Tarefas avulsas
            </div>

            <div class="div-element" v-for="task in expandedCriterias.tasksWithoutParent" :key="task.id">
                {{ task.designation }}
            </div>
        </div>
        
        <div v-show="expandedCriterias.opSkillsWithoutParent.length > 0">
            <div class="div-list-name">
                Competências operativas avulsas
            </div>

            <div class="div-element" v-for="opSkill in expandedCriterias.opSkillsWithoutParent" :key="opSkill.id">
                {{ opSkill.designation }}
            </div>
        </div>
    </div>
</template>

<style scoped>

.div-list-name {
    margin: 10px 0;
    font-weight: bold;
}

.div-element {
    background-color: var(--default-app-alt-line-color);
    padding: 5px;
    margin-top: 2px;
    display: flex;
    gap: 5px;
    align-items: center;
}

.div-container {
    width: 98%;
    height: 100%;
    padding: 1% 2% 1% 1%;
}

#div-teams {
    display: flex;
    gap: 5px;
    cursor: default;
}

.div-team + * {
    padding-left: 10px;
    border-left: 1px solid black;
}

#div-user-content {
    background-color: white;
    padding: 20px;
    width: 50%;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    border-radius: 5px;
}

#div-user-header {
    font-size: 1.3em;
    display: flex;
    align-items: center;
    gap: 30px;
}

#div-skills-data {
    border-top: 1px solid;
    padding-top: 10px;
    margin-top: 20px;
}

#div-name {
    display: flex;
    justify-content: space-between;
}

.img-user-photo {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    object-fit: cover;
}

.div-header-container {
    display: flex;
}

.show-all-container {
    width: max-content;
}

.show-all-container i {
    margin-left: 10px;
}

.show-all-container:hover {
    color: var(--default-hover-color);
}

.div-activities-container {
    display: flex;
    justify-content: space-between;
}
</style>
